import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, MasterPages, Method } from "../../../commonFunctions/CommonFunctions";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { AllPermissions, getPermissions } from "../../../commonFunctions/PermissionManger";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";


export const MeetingList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getMeetingPermission;
    const navigate = useNavigate();
    const [meetingListData, setMeetingListData] = useState<any>([])
    const { showMessage } = useSnackbar();
    const isMobile = IsSmallScreen();

    const [totalCount, setTotalCount] = useState<any>(0);
    const dispatch = useDispatch();
    const source = {
        url: "leads/search",
        page: 1,
        pageSize: 10,
        filter: [
            {
                "field": "leadType",
                "operator": "eq",
                "value": "0"
            }
        ],
        sort: [],
    };


    useEffect(() => {

        const getDeals = async () => {
            try {

                const response: any = await callAPI('meetings', Method.GET, null, null);
                setTotalCount(response?.length || 0)
                const data: any = response.sort((a: any, b: any) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
                setMeetingListData(data || []);


            }
            catch (e) {

            }
        }
        getDeals();
    }, [])
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/meeting/edit/${row?.id}`)
        }

    };
    const columns: IColumns[] = [
        {
            header: "Title",
            fieldName: "title",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "meetingType",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Start",
            fieldName: "startDateTime",
            tooltip: true,
            type: 'dateTime'
        },
        {
            header: "End",
            fieldName: "endDateTime",
            tooltip: true,
            type: 'dateTime'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Title",
            fieldName: "title",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "meetingType",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Start",
            fieldName: "startDateTime",
            tooltip: true,
            type: 'date',
            sm: 6,
            labelSx: { paddingLeft: 2 }
        },
        {
            header: "End",
            fieldName: "endDateTime",
            tooltip: true,
            type: 'date',
            sm: 6,
            labelSx: { paddingLeft: 2 }
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];

    const handleClick = () => {
        navigate('/meeting/create')
    }

    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="meetingMainListGrid"
                        title="Meetings"
                        columns={columns}
                        data={meetingListData}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile && meetingListData.length > 0 &&
                        <WSMobileDataGridAdvanced title={'Meetings'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="meetingMainListGrid" data={meetingListData} />
                    }
                </Grid>
                    : <PermissionDenied />}
            </Grid>
        </>
    )
})